(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5450],{

/***/ 75450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ layouts_ContactsPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./layouts/ContactsPage/ContactsPage.module.scss
var ContactsPage_module = __webpack_require__(9950);
var ContactsPage_module_default = /*#__PURE__*/__webpack_require__.n(ContactsPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/ContactsPage/ContactsPage.js









var Contacts = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 412).then(__webpack_require__.bind(__webpack_require__, 70412));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70412)];
    }
  }
});

var ContactsPage = function ContactsPage() {
  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'contacts'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
      contactsHref = _getLinkProps2[0],
      _contactsAs = _getLinkProps2[1],
      contactsTitle = _getLinkProps2[2];

  var breadCrumbsСontacts = [{
    slug: contactsHref,
    name: contactsTitle
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (ContactsPage_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ContactsPage_module_default()).breadCrumbs,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          type: "news",
          breadcrumbs: breadCrumbsСontacts
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h1",
        mb: "large",
        children: "\u041D\u0430\u0448\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Contacts, {})]
  });
};

/* harmony default export */ var ContactsPage_ContactsPage = (ContactsPage);
;// CONCATENATED MODULE: ./layouts/ContactsPage/index.js

/* harmony default export */ var layouts_ContactsPage = (ContactsPage_ContactsPage);

/***/ }),

/***/ 9950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"ContactsPage_breadCrumbs__3D_tK","section":"ContactsPage_section__LRxha","load":"ContactsPage_load__oX3gh"};

/***/ })

}]);